var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationShipmentAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5L10 8.99018C9.99999 8.75504 10.0628 8.52416 10.182 8.32147C10.3012 8.11878 10.4725 7.95164 10.678 7.83736L20.5917 2.33177H20.5904C20.9822 2.11418 21.423 2 21.8712 2C22.3194 2 22.7601 2.11418 23.1519 2.33177L33.0644 7.83736C33.2699 7.95164 33.4411 8.11878 33.5603 8.32147C33.6795 8.52416 33.7424 8.75504 33.7424 8.99018V19.8523C33.7423 20.3227 33.6164 20.7846 33.3777 21.19C33.1391 21.5954 32.7964 21.9296 32.3851 22.158L23.1519 27.2889C22.7601 27.5065 22.3194 27.6207 21.8712 27.6207C21.423 27.6207 20.9822 27.5065 20.5904 27.2889L18 26",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.21484L21.8712 14.8099M21.8712 14.8099L33.7424 8.21484M21.8712 14.8099V28.0001",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9365 11.5121L27.8077 4.91699",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 22.7143,
    r: 7.71429,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49414 26.9965C6.78929 26.9718 7.05931 26.8206 7.23449 26.5818L11.4892 20.7815C11.8236 20.3257 11.7251 19.6851 11.2692 19.3507C10.8134 19.0163 10.1728 19.1148 9.83837 19.5706L6.27952 24.4223L4.7374 22.9223C4.33215 22.5281 3.68406 22.537 3.28987 22.9423C2.89568 23.3476 2.90465 23.9956 3.30991 24.3898L5.69534 26.7101C5.90765 26.9166 6.19899 27.0211 6.49414 26.9965Z",
    fill: "#06CEA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationShipmentAvailable);
export default __webpack_public_path__ + "static/media/notification-shipment-available.8a432b5f96a242a0aac500fb8744d0a5.svg";
export { ForwardRef as ReactComponent };